import type { BoardProps } from "../shared-sortaballs/Board"

import { Board as SharedBoard } from "../shared-sortaballs/Board"
import { PALETTE } from "./palette"

type GameBoardProps = Omit<BoardProps, "cssPrefix" | "palette">

export function Board(input: GameBoardProps) {
	return <SharedBoard {...input} cssPrefix="sa" palette={PALETTE} />
}
